import { ArrowIcon, Box, Flex, Heading } from '@modusign/design-system';
import { ReactNode } from 'react';
import { useDispatch } from 'react-redux';

import DocumentZoomButton from '@app/components/DocumentZoomButton';
import Header from '@app/components/Header';
import PDFDocumentContentLayout from '@app/libs/reactPdfJs/components/PDFDocumentContentLayout';
import PDFDocumentPageLayout from '@app/libs/reactPdfJs/components/PDFDocumentPageLayout';
import PDFContainer from '@app/libs/reactPdfJs/containers/PDFContainer';
import { zoomIn, zoomOut } from '@app/libs/reactPdfJs/store/actions';

interface PreviewPageProps {
  title: string;
  src: string;
  bottomBar?: ReactNode;
  onExit: () => void;
}

export default function PreviewPage({ title, src, bottomBar, onExit }: PreviewPageProps) {
  const dispatch = useDispatch();

  const handleZoomIn = () => dispatch(zoomIn());
  const handleZoomOut = () => dispatch(zoomOut());

  return (
    <PDFDocumentPageLayout bg="bodySecondaryBase" height="100vh" overflow="hidden" width="100vw">
      <Header alignItems="center" px={3}>
        <Flex flex={1} justifyContent="flex-start">
          <Flex alignItems="center" padding={[null, null, '10px']}>
            <Box
              as="button"
              color="textNeutralUltraLight"
              fontWeight="medium"
              sx={{
                '&:hover': {
                  color: 'textNeutralLightest',
                },
              }}
              type="button"
              onClick={onExit}
            >
              <ArrowIcon direction="left" mr={3} /> 나가기
            </Box>
          </Flex>
        </Flex>
        <Heading
          as="h1"
          color="white"
          display={['none', null, 'block']}
          fontSize="md"
          fontWeight="medium"
        >
          {title}
        </Heading>
        <Flex flex="1" justifyContent="flex-end">
          <Flex padding={[null, null, '10px']}>
            <DocumentZoomButton onZoomIn={handleZoomIn} onZoomOut={handleZoomOut} />
          </Flex>
        </Flex>
      </Header>
      <PDFDocumentContentLayout
        sx={{
          '.FormPreview-bar-container': {
            display: ['none', null, 'block'],
          },
        }}
      >
        <PDFContainer src={src} thumbnailContainerClassName="FormPreview-bar-container" />
      </PDFDocumentContentLayout>
      {bottomBar}
    </PDFDocumentPageLayout>
  );
}
